import { observer } from 'mobx-react-lite';
import style from './style.module.scss';
import { useStore } from '../../lib/hooks/useStore';
import { useEffect } from 'react';
import MessageBox from '../message-box';
import bpkLogoImage from '../../assets/bpk-logo.png';

interface GenericPageProps {
	title: string;
	message: string;
	imageSrc?: string;
	imageAlt?: string;
}

const GenericPage = observer(function ({ title, message, imageSrc, imageAlt }: GenericPageProps) {
	const {
		uiStore: { pushUIState, popUIState },
	} = useStore();

	useEffect(() => {
		// Push current UI state and apply overrides for this page
		pushUIState({ title, isBackEnabled: false, canCancel: false, isNavCollapsed: true });

		// Restore previous UI state on unmount
		return () => popUIState();
	}, []);

	return (
		<div className={style.page}>
			<main className={[style.page__main, style.main].join(' ')}>
				{imageSrc && <img className={style.main__icon} src={imageSrc} alt={imageAlt ?? ''} />}
				<MessageBox className={style.main__message} type={'warning'}>
					{message}
				</MessageBox>
			</main>
			<img className={style.page__logo} src={bpkLogoImage} alt='BillPay Kiosk' />
		</div>
	);
});

export default GenericPage;
